/**
 * Link da tela Minha assinatura de uma contabilidade, para o suporte/CS mandar ao cliente.
 *
 * Quem abre sem estar logado cai no login e volta para cá depois de entrar: o
 * `redirectUnauthenticatedToAuth` guarda a rota de destino.
 *
 * Devolve `null` sem contabilidade, para quem chama não copiar um
 * `/contabilidade/undefined/...` que leva o cliente a lugar nenhum.
 */
export function mySubscriptionUrl(accountingId, baseUrl = publicSettings.url) {
    if (!accountingId) return null;
    return `${baseUrl}/contabilidade/${accountingId}/minha-assinatura`;
}
